import { render, staticRenderFns } from "./boutique_course.vue?vue&type=template&id=762b7de0&scoped=true&"
import script from "./boutique_course.vue?vue&type=script&lang=js&"
export * from "./boutique_course.vue?vue&type=script&lang=js&"
import style0 from "./boutique_course.vue?vue&type=style&index=0&id=762b7de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b7de0",
  null
  
)

export default component.exports